var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-name",
            label: "Nom",
            "label-for": "input-name",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-name", type: "text", required: "" },
            model: {
              value: _vm.form.train_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_name", $$v)
              },
              expression: "form.train_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-description",
            label: "Description",
            "label-for": "input-description",
          },
        },
        [
          _c("b-form-textarea", {
            attrs: { id: "input-description", type: "text", required: "" },
            model: {
              value: _vm.form.train_description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_description", $$v)
              },
              expression: "form.train_description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-usages",
            label: "Usages",
            "label-for": "input-usages",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.usagesValues, multiple: "" },
            model: {
              value: _vm.form.train_usages,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_usages", $$v)
              },
              expression: "form.train_usages",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-needs",
            label: "Besoins",
            "label-for": "input-needs",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.needsValues, multiple: "" },
            model: {
              value: _vm.form.train_needs,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_needs", $$v)
              },
              expression: "form.train_needs",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-offers",
            label: "Offres",
            "label-for": "input-offers",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.offersValues, multiple: "" },
            model: {
              value: _vm.form.train_offers,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_offers", $$v)
              },
              expression: "form.train_offers",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "separation_line" }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-2", attrs: { "align-h": "end" } },
        [
          _c(
            "b-col",
            {
              staticClass: "text-right",
              attrs: { cols: "8", "align-self": "end" },
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modal-document-add",
                      modifiers: { "modal-document-add": true },
                    },
                  ],
                  attrs: { variant: "success" },
                },
                [_vm._v("Ajouter un nouveau document")]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "modal-document-add",
                    title: "Ajouter un nouveau document de formation",
                    scrollable: "",
                    "hide-footer": "",
                  },
                },
                [
                  _c("div", { staticClass: "alert-warning mt-3 mb-3 p-2" }, [
                    _vm._v(
                      "Attention, le nom du document fait foi et doit être unique."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    { on: { submit: _vm.onSubmitDocument } },
                    [
                      _c("b-form-file", {
                        attrs: {
                          state: Boolean(_vm.form.list),
                          placeholder:
                            "Choisissez un fichier ou déposez-le ici...",
                          "drop-placeholder": "Déposez-le ici...",
                        },
                        model: {
                          value: _vm.form.list,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "list", $$v)
                          },
                          expression: "form.list",
                        },
                      }),
                      _vm._v(" "),
                      _vm.form.list
                        ? _c("div", { staticClass: "mt-3" }, [
                            _vm._v(
                              "Fichier sélectionné: " +
                                _vm._s(_vm.form.list ? _vm.form.list.name : "")
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-center mt-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "text-center",
                                  attrs: { type: "submit", variant: "primary" },
                                },
                                [_vm._v("Importer")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-documents",
            label: "Documents",
            "label-for": "input-documents",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.documentsValues, multiple: "" },
            model: {
              value: _vm.form.train_documents,
              callback: function ($$v) {
                _vm.$set(_vm.form, "train_documents", $$v)
              },
              expression: "form.train_documents",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [_vm._v("Enregistrer")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }